export type GrowlVariant = 'success' | 'error' | 'info';

type GrowlItem = { id: string; message: string; variant: GrowlVariant };

type Listener = (item: GrowlItem) => void;
let idSeq = 0;
let listener: Listener | null = null;

function nextId(): string {
  return `g-${++idSeq}-${Date.now()}`;
}

export function setGrowlListener(next: Listener | null): void {
  listener = next;
}

/** Notificación en pantalla (esquina). El host debe estar montado (App → GrowlProvider). */
export function showGrowl(message: string, variant: GrowlVariant = 'info'): void {
  if (!message.trim() || !listener) return;
  listener({ id: nextId(), message: message.trim(), variant });
}
